import View from "../framework/view";
import {Notification} from "../framework/view";
import Server from "../server";
import template from "../../pugc/signup-form";
import {formToJson} from "../misc/utils";

export class SignupForm extends View {

    static classname = "signup-form-view";

    private readonly server = Server.instance();

    private verbose : boolean;

    private signedUp = false;

    autologin: boolean = false;

    constructor(verbose: boolean) {
        super(SignupForm.classname);
        this.verbose = verbose;
    }

    protected render0(): JQuery<HTMLElement> {
        const data = {
            signedUp: this.signedUp,
            verbose: this.verbose
        };

        const out = this.pug(template, data);
        out.find(".with-validation").validate({
            rules: {
                given_name: "required",
                family_name: "required",
                email: "required",
            }
        });
        return out;
    }

    signup() {
        const form = this.elt().find(".signup-form");

        if (! form.valid()) {
            return;
        }

        const data : { given_name?: string, family_name?: string, email?: string, auto_login: boolean} = {
            auto_login: this.autologin
        };
        formToJson(form, data);

        this.server.signup(data).then((newUser) => {
            this.signedUp = true;
            this.update();
            this.notify(new SignupNotification(data.email as string, newUser))
        });

    }

}

export class SignupNotification extends Notification {
    public email: string;
    public newUser: boolean;
    constructor(email: string, newUser: boolean) {
        super("SignupNotification")
        this.email = email;
        this.newUser = newUser;
    }
}

View.on(
    "." + SignupForm.classname,
    "click",
    ".signup",
    function(that: SignupForm, event, elt) {
        event.preventDefault();
        that.signup();
    });
